import { Box, Paper } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import type { FlagName } from '../../utils/feature-flags';
import { getStoredOverrideNames, onFeatureOverridesChange } from '../../utils/feature-flags';
import style from './feature-flag-banner.module.scss';

export const FeatureFlagBanner: React.FC = () => {
  const [names, setNames] = useState<FlagName[] | undefined>(() => getStoredOverrideNames());

  useEffect(() => {
    const refresh = () => setNames(getStoredOverrideNames());
    const unsubscribe = onFeatureOverridesChange(refresh);
    refresh();
    return () => {
      unsubscribe();
    };
  }, []);

  if (!names || names.length === 0) return null;

  return (
    <Box className={style.featureFlagBanner}>
      <Paper
        elevation={4}
        square
        className={style.banner}
      >
        <b className={style.header}>TEST</b>
        {names.map((name, index) => (
          <span key={index} className={style.name}>
            {name}
          </span>
        ))}
      </Paper>
    </Box>
  );
};
